import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

function Modal({ show = false, onClose, children, className = '' }) {
  if (!show) {
    return;
  }

  return (
    <div className={`modal-container ${className}`}>
      <div className="modal pixel-corners">
        <Button className="modal-close" onClick={onClose}>
          X
        </Button>
        {children}
      </div>
    </div>
  );
}

Modal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.any,
  className: PropTypes.string
};

export default Modal;
